<template>
  <section class="quote-buy">
    <div class="abs-top-right">
      <v-button
        size="small"
        @click="() => $emit('cancel')">Cancel</v-button>
    </div>
    <h1>Pay on behalf</h1>
    <div class="payment-main main-contain">
      <div>
        <div class="content">
          <h2>Online Payment</h2>
          <new-payment-form
            :customerId="customerId"
            :customerName="customer? customer.isrd_nm: ''"
            :orderId="orderId"
            :is-new-sme="isNewSme"
            :transactionFee="getTransactionFee"
            :getCredit="getCredit"
            :amount="amount"
            @success="paymentSuccess"
            @handlerBlur="handlerBlur"
            @change-credit="handlerChangeCredit"
          />

          <!--          <div class="content content-border">-->
          <!--            <h2>Send Payment Link</h2>-->
          <!--            <v-button-->
          <!--            >Using SMS</v-button>-->
          <!--            <v-button-->
          <!--            >Email</v-button>-->
          <!--          </div>-->
          <!--          <send-link-->
          <!--            :orderId="orderId"-->
          <!--            :customerId="formData.customer_id"-->
          <!--            :quote_no="formData.quotation_number"-->
          <!--          ></send-link>-->
        </div>
      </div>
      <div>
        <div>
          <div class="company-logo">
            <img
              :src="formData.company_logo"
              alt="company"
            />
            <span class="label">{{ formData.plan }}</span>
          </div>
          <div class="flex-content">

            <div class="flex-box">
              <div
                v-for="(item, index) in sidebarPremium"
                :key="index"
                class="flex-info">
                <span>{{ item.item }}</span>
                <span>{{ item.premium | formatMoney(2, true) }}</span>
              </div>
              <div
                v-if="getCredit"
                class="flex-info ">
                <span>Credit Point</span>
                <span class="amount">{{'-'+ getCredit |formatMoney(2, true)}}</span>
              </div>
              <div
                v-if="getTransactionFee"
                class="flex-info transa-color">
                <span>Transaction Fee</span>
                <span>+{{ getTransactionFee |formatMoney(2, true)}}</span>
              </div>
              <div
                class="flex-info total-amount">
                <span>Total Payable</span>
                <span class="amount">{{ amount | formatMoney(2, true) }}</span>
              </div>
            </div>

            <div class="form-item">
              <span class="label">Promo Code</span>
              <div class="form-input">
                <v-input
                  v-model="code"
                  append="Apply"
                  @handlerAppend="applyCode"/>
              </div>
            </div>
            <div class="form-item">
              <div
                v-if="!coupon_code"
                class="coupon-button">
                <v-button
                  size="medium "
                  @click="handlerCoupon">
                  <font-awesome-icon
                    icon="plus"
                    class="margin-right"></font-awesome-icon>
                  <span>Add Coupon</span>
                </v-button>
              </div>
              <div
                v-else
                class="coupon-data">
                <div class="coupon-content">
                  <p class="coupon-title">{{formData.coupon.title}}</p>
                  <p class="coupon-code">{{formData.coupon.coupon_code}}</p>
                  <p class="coupon-des">{{formData.coupon.description}}</p>
                </div>
                <div class="coupon-button">
                  <v-button
                    size="medium "
                    @click="handlerCoupon">
                    <span>Change Coupon</span>
                  </v-button>
                </div>
              </div>
            </div>

            <!-- <span class="label">{{ getOptionName('classOptions', formData.class_id) }} Insurance {{ getOptionName('coverTypeOptions', formData.trm_of_cvr) }} Plan</span> -->
            <!--            <v-button-->
            <!--              type="info"-->
            <!--              @click="planClick">Plan Info</v-button>-->
            <!--            <plan-quote-info :formData="formData" />-->
            <!--            <div class="total-box">-->
            <!--              <span>Total</span>-->
            <!--              <span-->
            <!--                :style="{ fontSize: cssFontSize(formData.amount, 170, 24) }"-->
            <!--                class="amount">{{ formData.amount | formatMoney(2, true) }}</span>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
      <!--      <div class="card send-container">-->
      <!--        <h1>Send Payment Link</h1>-->
      <!--        <v-button-->
      <!--          size="small"-->
      <!--          type="success">Send Payment Link via SMS</v-button>-->
      <!--        <v-button-->
      <!--          size="small"-->
      <!--          type="primary">Email</v-button>-->
      <!--      </div>-->
      <!--      <div class="card payment-container">-->
      <!--        <h1>Online Payment</h1>-->
      <!--        <payment-form-->
      <!--          :orderId="orderId"-->
      <!--          :customerId="customerId"-->
      <!--          :customerName="customer.isrd_nm? customer.isrd_nm: ''"-->
      <!--          @success="paymentSuccess" />-->
      <!--      </div>-->

    </div>
    <coupon-dialog
      ref="coupon-dialog"
      :customerId="customerId"
      :customer="customer"
      :orderId="orderId"
      @coupon="computedCoupon">
    </coupon-dialog>
  </section>
</template>

<script>
import newPaymentForm from '@/views/components/newPaymentForm'
import sendLink from '@/views/components/sendLink'
import { mapState,mapActions } from 'vuex'
import {getCarQuoteDetail, getHomefireQuoteDetail, getHousemaidQuoteDetail, getInteriorQuoteDetail} from '@api/quote'
import {applyOrderCode, verifyPromoCode} from '@api/order'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import CouponDialog from '../../../quoting/dialogs/coupon-dialog'


export default {
  name: 'QuoteBuy',
  components: {
    newPaymentForm,
    CouponDialog
  },
  mixins: [MixinOptions, MixinFormat],

  props: {
    orderId: [String, Number],
    pcyId: [String, Number],
    customerId: [String, Number],
    customer: {
      type: Object,
      default: () => ({})
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    isNewSme: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      checkedVerify: false,
      checking: false,
      isPayment: false,
      getCredit:'',
      getTransactionFee:0,
      amount:0,
      code:'',
      coupon:''
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    sidebarPremium() {
      if(!this.formData.quote_coverage_list) {
        return []
      }
      let premium = this.formData.quote_coverage_list.sidebar_premium.filter(item => item.name != 'paid')

      return premium
    },
    coupon_code(){
      let {coupon={}} = this.formData
      if(coupon&&coupon.coupon_code)
      {
        this.setCouponData(coupon.coupon_code)
        return true
      }else{
        this.setCouponData(null)
        return false
      }

    }
  },
  watch:{
    formData:{
      immediate:true,
      handler(val){
        this.amount = val.amount
      }
    },
    coupon_code:{
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          let {coupon={}} = this.formData
          this.coupon = coupon
        }
      }
    }
  },
  methods: {
    ...mapActions('coupon', ['setCouponData']),
    handlerCoupon(){
      this.$refs['coupon-dialog'].changeDialog()
    },
    paymentSuccess({ pcy_id }) {
      this.$router.push({
        path: '/records/policy/detail',
        query: {
          id:this.orderId,
          pcy_id,
          product_id: this.productId,
        }
      })
    },
    handlerBlur(credit){
      this.credit = credit
      if(credit != this.getCredit)
        this.network().applyOrderCode()
    },
    // 切換 use credit 不更新 credit input
    handlerChangeCredit(credit, status) {
      this.credit = credit
      this.network().applyOrderCode({
        updateCredit: false
      })
    },
    applyCode(){
      this.network().applyOrderCode()
    },
    computedCoupon(data){
      this.coupon = data
      this.formData.coupon = data
      this.applyCode()
    },
    handler() {
      return {
        handlerGetOrderDetail: async () => {
          switch(Number(this.productId)) {
            case 12:
              await this.network().getHousemaidQuoteDetail()
              break
            case 11:
              await this.network().getCarQuoteDetail()
              break
            case 15:
              await this.network().getInteriorQuoteDetail()
              break
            case 17:
              await this.network().getHomefireQuoteDetail()
              break
          }
        }
      }
    },
    network() {
      return {
        verifyPromoCode: async () => {
          const { data } = await verifyPromoCode({
            customer_id: this.customerId,
            code: this.code
          })
          if(data.code == 1000) {
            this.network().applyOrderCode()
          }
        },
        applyOrderCode:async ({ updateCredit = true, updateOrder = true } = {}) => {
          let { data } = await applyOrderCode({
            order_id: this.orderId,
            code:this.code,
            credit:this.credit,
            customer_id: this.customerId,
            coupon:this.coupon.coupon_code||''
          })
          let { credit, transaction_fee, amount	} = data
          if(updateCredit) {
            this.getCredit = credit
          }
          this.getTransactionFee = transaction_fee
          this.$set(this.formData, 'amount', amount)
          this.amount = amount
          this.$parent.updateTicketsData()

        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.quote-buy {
    position: relative;
    h1 {
    padding-bottom: 30px;
    font-size: 24px;
      padding-left: 30px;
  }
  .payment-main {
      // justify-content: space-between;
      .card {

          width: 554px;
      }
  }
}

//.main-contain {
//  position: relative;
//  display: flex;
//  flex-wrap: wrap;
//  padding: 0 ;
//  justify-content: space-between;
//
//  > div {
//    width: 50%;
//
//    .content {
//      padding: 31px 0;
//    }
//    .content-border{
//      margin-top: 20px;
//      //border-bottom: 1px solid #E1E4E8;
//      border-top: 1px solid #E1E4E8;
//    }
//  }
//}

.main-contain {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding: 0 30px;
  justify-content: space-between;
  >div{
    width: 50%;
    .content-border{
      margin-top: 30px;
      padding-top: 20px;
      //border-bottom: 1px solid #E1E4E8;
      border-top: 1px solid #E1E4E8;
    }
  }
  >div:last-child{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 31px 0;
  }
  .send-container {
    margin-right: 15px;
    width: 450px;
  }
  .payment-container {
    width: 450px;
    .verify-container {
      & > span:first-child {
        display: block;
        padding-bottom: 15px;
        font-size: 16px;
        color: #616266;
      }
      .verify-next {
        padding-top: 15px;
        .waiting {
          display: block;
          padding-bottom: 10px;
          color: #616266;
          font-size: 16px;
          span {
            display: inline-block;
            padding-left: 5px;
          }
        }
      }
    }
  }
}
.company-logo {
  margin-top: 31px;
  display: flex;
  width: 280px;
  img {
    // width: 100%;
    //height: 100%;
    margin-right: 26px;
    margin-left: 11px;
    height: 51px;
  }
}
.flex-content {
  width: 280px;
  .flex-box {
    border-radius: 5px;
    border: 1px solid #E1E4E8;
    width: 280px;
    margin: 16px 0;

    .flex-info {
      display: flex;
      justify-content: space-between;
      padding: 23px 15px;
      border-bottom: 1px solid #E1E4E8;

      span:first-child {
        color: #586069;
        font-size: 14px;
        font-weight: 500;
      }

      span:last-child {
        color: #24292E;
        font-size: 14px;
      }
    }

    .total-amount {
      background: #f6f8fa;
      border-bottom: 0;
    }
    .transa-color{
      span{
        color: rgb(205,43,56)!important;
      }

    }

    .amount {
      color: #24292E;
      font-weight: bolder;
    }
  }
  .coupon-button{
    .el-button{
      width: 100%;
    }
    .margin-right{
      margin-right: 10px;
    }
  }
  .coupon-data{
    width: 100%;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #D1D5DA;
    border-radius: 5px;
    padding: 16px;
    .coupon-title{
      color: #24292E;
      font-size: 16px;
      font-weight: 600;
      text-overflow: ellipsis;
      word-break: break-word;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .coupon-code{
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #6A737D;
    }
    .coupon-des{
      text-overflow: ellipsis;
      word-break: break-word;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      font-size: 12px;
      margin-top: 5px;
      -webkit-box-orient: vertical;
      color: #6A737D;
    }
  }
}
</style>